"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIFireAlarm;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UIAlert = _interopRequireDefault(require("../alert/UIAlert"));

function UIFireAlarm(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(_UIAlert.default, (0, _extends2.default)({}, rest, {
    className: (0, _classNames.default)('private-alert--system-wide', 'private-alert--page-wide', className)
  }));
}

UIFireAlarm.propTypes = (0, _extends2.default)({}, _UIAlert.default.propTypes, {
  type: _react.PropTypes.oneOf(['danger', 'info', 'warning']).isRequired
});
UIFireAlarm.defaultProps = (0, _extends2.default)({}, _UIAlert.default.defaultProps, {
  type: 'warning'
});
UIFireAlarm.displayName = 'UIFireAlarm';
module.exports = exports.default;